module.exports = __webpack_public_path__ + "static/media/wavy-sm_green.e3ecc822.svg";